import { AES, mode, pad, enc} from 'crypto-js'
/**
 * AES加密
 * @param {需要加密的字符串} str
 * @param {密钥} key
 * @returns
 */

export function aesEncrypt(str, key) {
  key = enc.Utf8.parse(key)
  str = enc.Utf8.parse(str)
  return AES.encrypt(str, key,{
    mode: mode.ECB,
    padding: pad.Pkcs7
  }).toString()
}